module.exports = __webpack_public_path__ + "static/media/shells_header_desktop.741de89a.png";